import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { MenuItem } from "../interfaces/menu-item.interface";
import { trackById } from "@vex/utils/track-by";
import { VexPopoverRef } from "@vex/components/vex-popover/vex-popover-ref";
import { Router, RouterLink } from "@angular/router";
import { MatRippleModule } from "@angular/material/core";
import { NgClass, NgFor, NgIf } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { ProfileService } from "src/app/services/profile.service";
import { Profile } from "src/app/interfaces";
import { AuthService } from "src/app/services/auth.service";
import { ThemeService } from "src/app/services/theme.service";

@Component({
  selector: "vex-toolbar-user-dropdown",
  templateUrl: "./toolbar-user-dropdown.component.html",
  styleUrls: ["./toolbar-user-dropdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    NgClass,
    NgIf,
  ],
})
export class ToolbarUserDropdownComponent implements OnInit {
  items: MenuItem[] = [
    {
      id: "1",
      icon: "mat:account_circle",
      label: "My Profile",
      description: "Personal Information",
      colorClass: "text-teal-600",
      route: "/profile",
    },
    /* {
      id: "2",
      icon: "mat:code",
      label: "API Docs",
      description: "Spec & Documentation",
      colorClass: "text-primary-600",
      route: "/api-docs",
    },
    {
      id: '3',
      icon: 'mat:list_alt',
      label: 'My Projects',
      description: 'Tasks & Active Projects',
      colorClass: 'text-amber-600',
      route: '/apps/scrumboard'
    },
    {
      id: '4',
      icon: 'mat:table_chart',
      label: 'Billing Information',
      description: 'Pricing & Current Plan',
      colorClass: 'text-purple-600',
      route: '/pages/pricing'
    } */
  ];

  themes = [
    {
      id: "light",
      label: "Light mode",
      icon: "mat:light_mode",
      colorClass: "text-green-600",
    },
    {
      id: "dark",
      label: "Dark mode",
      icon: "mat:dark_mode",
      colorClass: "text-orange-600",
    },
  ];

  activeTheme;

  trackById = trackById;

  profile: Profile = <Profile>{};

  constructor(
    private cd: ChangeDetectorRef,
    private popoverRef: VexPopoverRef<ToolbarUserDropdownComponent>,
    private authService: AuthService,
    private profileService: ProfileService,
    private themeService: ThemeService,
    private router: Router,
  ) {
    this.profileService.getProfile$().subscribe((profile) => {
      this.profile = profile
      this.cd.markForCheck();
    });
    this.activeTheme = this.themeService.getTheme() === 'light' ? this.themes[0] : this.themes[1];
  }
  

  ngOnInit() {}

  profileDisplayName(): string {
    return this.profileService.getProfileDisplayName();
  }

  setTheme(theme: any) {
    this.activeTheme = theme;
    // this.profileService.updateProfile(this.profile._id, {theme: theme.id}).subscribe();
    this.themeService.setTheme(theme.id);
    this.cd.markForCheck();
  }

  close() {
    this.popoverRef.close();
  }

  signOut() {
    this.authService.signOut().then(() => {
      this.router.navigate(['/sign-in']);
    });
    this.close();
  }

}
